import React, { useState } from 'react';
import copy from 'copy-to-clipboard';
import { IconButton, Tooltip } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DoneIcon from '@mui/icons-material/Done';

export const CopyButton = ({ copyData }: { copyData: string }) => {
    const [isCopied, setIsCopied] = useState(false);

    const handleCopyClick = () => {
        setIsCopied(true);
        copy(copyData);
        // Optionally revert back to the original "Copy" icon after some time
        setTimeout(() => setIsCopied(false), 2000);
    };

    const enterDelay = 700;

    return (
        <Tooltip title={isCopied ? "Copied" : "Copy"} enterDelay={enterDelay}>
            <IconButton
                onClick={handleCopyClick}
                size="small">
                {isCopied ? <DoneIcon /> : <ContentCopyIcon />}
            </IconButton>
        </Tooltip>
    );
};